'use strict';

var UserManagementToolbarController = function UserManagementToolbarController($scope, $rootScope, userManagementToolbarBookmarksService) {
  $scope.modeList = userManagementToolbarBookmarksService.getBookmarks();
  $scope.selectedMode = $scope.modeList[0].value;
  $scope.$watch('selectedMode', function () {
    $rootScope.$broadcast('user-management:modeChanged', $scope.selectedMode);
  });
};
UserManagementToolbarController.$inject = ['$scope', '$rootScope', 'UserManagementToolbarBookmarksService'];
module.exports = UserManagementToolbarController;